<template>
  <div>
    <loading ref="loading" />

    <transition name="page" mode="out-in">
      <component :is="layout" v-if="layout" />
    </transition>
  </div>
</template>

<style lang="scss">
html {
  height: 100%;
  overflow-x: hidden;
}

body {
  min-height: 100%;
  margin: 0;
  overflow-x: hidden;
  background-color: var(--portal-bg) !important;
  color: var(--portal-text);
}

#app {
  min-height: 100%;
}
</style>

<script>
import Loading from "./Loading";

// Load layout components dynamically.
const requireContext = require.context("./layouts", false, /.*\.vue$/);

const layouts = requireContext
  .keys()
  .map((file) => [file.replace(/(^.\/)|(\.vue$)/g, ""), requireContext(file)])
  .reduce((components, [name, component]) => {
    components[name] = component.default || component;
    return components;
  }, {});

export default {
  el: "#app",
  components: {
    Loading,
  },
  data: () => ({
    layout: null,
    defaultLayout: "BasicLayout",
  }),
  mounted() {
    this.$loading = this.$refs.loading;
    this.syncLayoutFromRoute(this.$route);
  },

  watch: {
    $route(to) {
      this.syncLayoutFromRoute(to);
    },
  },

  methods: {
    /**
     * Fallback if router guard did not set layout (e.g. after lazy-load edge cases).
     */
    syncLayoutFromRoute(route) {
      if (this.layout || !route.matched.length) {
        return;
      }

      this.$nextTick(() => {
        if (this.layout) {
          return;
        }

        const record = route.matched[route.matched.length - 1];
        const component = record?.components?.default;
        if (component?.layout) {
          this.setLayout(component.layout);
        }
      });
    },
    /**
     * Set the application layout.
     *
     * @param {String} layout
     */
    setLayout(layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout;
      }

      this.layout = layouts[layout];
    },
  },
};
</script>
